
import { Component } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';
import { InnerMenuService } from '../../inner-menu.service';
import { NodeMenuModel } from '../../../shared/models/tree-menu.model';
import { Images } from '../../../shared/models/images.model';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'inner-menu-sidebar',
    templateUrl: './inner-menu-sidebar.component.html',
    styleUrls: ['./inner-menu-sidebar.component.css']
})
export class InnerMenuSidebarComponent extends SiriusBaseComponent<any> {
    Images = Images;
    currentTransaction: string = "";
    currentUrl: string = "";
    tree: NodeMenuModel[]; 
    constructor(private router: Router, private innerMenuService: InnerMenuService) {
        super();
    }
    OnInit() {
        var promise = this.innerMenuService.getInnerMenuSidebarItemsData(this.dataService).toPromise();
        promise.then((result) => {
            this.tree = <any> result;
            this.subscribeRouteSubscription();
        });
    }
    subscribeRouteSubscription() {
        this.currentUrl = this.router.url;
        this.router.events.subscribe(
            (event: NavigationEnd): void => {
                if (this.currentUrl !== this.router.url) {
                    this.currentUrl = this.router.url;
                }
            }
        );       
    }
}
